import React, { MutableRefObject, MouseEvent } from 'react'
import { VariableSizeList } from 'react-window'

export interface ExpandedAction {
  type: 'toggle' | 'clear'
  key: string
}
export function expandedReducer(
  state: { [key: string]: boolean },
  action: ExpandedAction
): { [key: string]: boolean } {
  switch (action.type) {
    case 'toggle':
      return { ...state, [action.key]: !state[action.key] }
    case 'clear':
      const { [action.key]: id, ...rest } = state
      return rest
  }
}

export interface TableContextProps {
  onToggleFavourite?: (favourite: string) => void
  expandedPositionsState: React.ReducerState<
    (state: { [p: string]: boolean }, action: ExpandedAction) => { [p: string]: boolean }
  >
  expandedPositionsDispatch: React.Dispatch<
    React.ReducerAction<
      (state: { [p: string]: boolean }, action: ExpandedAction) => { [p: string]: boolean }
    >
  >
  keyPropertyName: string
  listRef?: MutableRefObject<VariableSizeList | null>
  isRowActive?: (rowOriginalId: string) => boolean
  rowClickHandle?: (e: MouseEvent<HTMLDivElement>) => void
  onToggleAnalysisTrends?: (symbol: string) => void
}

export const TableContext = React.createContext<TableContextProps>({
  onToggleFavourite: favourite => {
    throw new Error('not implemented yet')
  },
  expandedPositionsDispatch: value => {
    throw new Error('not implemented yet')
  },
  keyPropertyName: 'id',
  expandedPositionsState: {},
})
